import { request } from '../utils/request';
import i18n from '../utils/i18n'
export async function createPayPayQRCodeAPI(merchantPaymentId, amount, orderDescription) {
  try {
    const response = await request({
      url: '/api/create-qrcode',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        merchantPaymentId,
        amount,
        orderDescription,
      },
      timeout: 10000, // タイムアウト時間を設定
    });

    // レスポンスデータを読み取る
    const data: any = response;
    console.log('data:', data);

    // レスポンスデータに成功メッセージが含まれているか確認
    if (data.url) {
      return { success: true, url: data.url };
    } else {
      throw new Error(data.error || 'QRコードの作成に失敗しました');
    }
  } catch (error) {
    console.error('エラー:', error);
    throw error;
  }
}

export async function checkPayPayPaymentDetailsAPI(orderId: string) {
  try {
    const response = await request({
      url: '/api/check-paypay-paymentDetails',
      method: 'GET',
      params: {
        orderId,
      },
      timeout: 10000, // タイムアウト時間を設定
    });

    // レスポンスデータを読み取る
    const data: any = response;
    console.log('支払い詳細のレスポンスデータ:', data);

    // レスポンスデータに成功メッセージが含まれているか確認
    if (data) {
      return { data };
    } else {
      console.error('支払い詳細を取得できませんでした');
    }
  } catch (error) {
    console.error('PayPay 支払い詳細の取得中にエラーが発生しました:', error);
  }
}

export function getPaymentAccountAPI(userId: string) {
  return request({
    url: '/api/get-paymentAccount',
    method: 'GET',
    params: { userId },
    timeout: 10000,
  });
}

export function updatePaymentAccountAPI(
  userId: string,
  paypay_account?: string,
  paypay_qr_url?: string | null
) {
  // 如果未提供或为空字符串则显式发送 null，便于服务端写入 NULL
  const qrValue = paypay_qr_url === undefined || paypay_qr_url === '' ? null : paypay_qr_url;

  return request({
    url: '/api/update-paymentAccount',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      userId,
      paypay_account,
      paypay_qr_url: qrValue,
    },
    timeout: 10000,
  });
}

export function sendCheckPaymentStatusAPI(params: {
  email: string;
  venueName: string;
  date: string;
  timeRange: string;
  price: number | string;
  paypayAccount: string;
  buyerName?: string;
  orderId?: string;
  lang?: 'zh' | 'ja' | string;
}) {
  const lang = params.lang === 'zh' || params.lang === 'ja'
    ? params.lang
    : (i18n.language === 'zh' || i18n.language === 'ja' ? i18n.language : 'ja');

  const body = { ...params, lang };
  return request({
    url: '/api/send-check-payment-status',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    timeout: 10000,
  });
}